import {ProductData} from "../providers/product/product-types";
import {useTranslation} from "react-i18next";

interface SinglePlanterProps {
    plant: ProductData;
    isSelected: boolean;
    onClick: (plant: ProductData) => void;
}

const SinglePlanter = ({plant, onClick, isSelected}: SinglePlanterProps) => {
    const {t} = useTranslation();
    const pointer = plant.disabled ? "opacity-50" : "cursor-pointer";
    return (
        <div onClick={() => {
            if(!plant.disabled) {
                onClick(plant)
            }
        }} className={`${pointer} flex flex-col items-center justify-center gap-1`}>
            <img className={isSelected ? 'h-9 w-9' : 'h-8 w-8'} src={plant.icon} alt={plant.title}/>
            <p className={`text-sm ${isSelected ? 'font-bold text-yellow-500' : plant.disabled ? 'font-light' : 'font-semibold'}`}>{plant.title}</p>
            {plant.state && <p className={`text-xs font-normal ${isSelected ? 'text-yellow-500' : 'text-indigo-900'}`}>{t('PRODUCT.STATE.' + plant.state)}</p>}
            {!plant.state && <p className="text-xs font-normal text-orange-900">&nbsp;</p>}
        </div>
    )
}

export default SinglePlanter;